import axios from "axios";
import { successHandling } from "../helpers/successHandling";

export const getOraLogAPI = async (device_id, t, successfulText) => {
  let res = await axios({
    url: `/api/v2/command/ora-upload-logs-send`,
    method: "POST",
    data: {
      device_id,
      execute_type: "upload_logs"
    }
  });
  successHandling(t, successfulText);
  return res.data;
};
